import React from 'react';
import {Button} from 'reactstrap';

const ErrorState = (props) => {
  return (
    <div className='error-container'>
      {props.message ?
        <div className='customer-message'>
          <p>{props.message}</p>
        </div> :
        <div>
          <p>資料抓取失敗，請隔一段時間後再嘗試開啟或重新整理網頁。</p>
          <p>若持續出現問題，請聯絡LOWI客服人員。</p>
        </div>
      }
      {props.onToggle && <Button onClick={props.onToggle}>確定</Button>}
    </div>
  );
};

export default ErrorState;



// WEBPACK FOOTER //
// ./src/components/widget/toolbar/errorState.js